// removed by extract-text-webpack-plugin
module.exports = {"containerTitle":"styles__containerTitle___25Pj-","customContainer":"styles__customContainer___3u9W4","box":"styles__box___IsH7j","cardContainer":"styles__cardContainer___2vxGk","itemsCard":"styles__itemsCard___18eBE","piped":"styles__piped___1AAIu"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/DataQuota/components/SummaryCard/styles.css
// module id = 3134
// module chunks = 0